import React, { ReactElement } from 'react';
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import { ThemeProvider } from '@mobilearch/react-ui';
import Home from '../pages/Home/Home';

const Router = (): ReactElement => {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default Router;
